import React from 'react';
import logoOnDark from '../../assets/brand/logo-on-dark.svg';

export function Hero() {
  const scrollToFeatures = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('features')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section
      className="text-center px-6"
      style={{ paddingTop: '80px', paddingBottom: '64px' }}
    >
      <div className="max-w-3xl mx-auto">
        {/* The stacked logo (icon over wordmark). The landing page is always
            dark, so only the on-dark version is used. width / height give the
            1024 x 576 ratio, so the space is reserved before it loads. */}
        <img
          src={logoOnDark}
          alt="MyCryptoPlanner"
          width={280}
          height={158}
          className="block mx-auto mb-10 w-[200px] sm:w-[280px] h-auto"
        />

        {/* Same font, weight and tracking as the section titles (h2: 26 to
            36px), one step up the scale: 30px on phones, 44px on desktop.
            Two lines from sm up (the forced break); below sm the break is
            dropped and the lines are balanced, so a 320px phone gets three
            even lines rather than "crypto." on its own. */}
        <h1
          className="font-semibold [text-wrap:balance]"
          style={{
            color: '#f4f1ea',
            fontSize: 'clamp(30px, 5vw, 44px)',
            letterSpacing: '-0.02em',
            lineHeight: 1.15,
          }}
        >
          Track, plan, and<br className="hidden sm:inline" /> strategise your crypto.
        </h1>

        <p
          className="mx-auto mt-6 text-[16px] sm:text-[17px] leading-relaxed max-w-2xl"
          style={{ color: 'rgba(244,241,234,0.6)' }}
        >
          The crypto planning space for investors, with popular stocks and ETFs included.
          Track your whole portfolio, log transactions, compare asset performance,
          see live market data, and plan your strategy.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#pricing"
            onClick={scrollToPricing}
            className="text-[14px] font-medium px-5 py-3 rounded-lg transition-transform hover:scale-[1.02]"
            style={{ backgroundColor: '#f4f1ea', color: '#0c0e12' }}
          >
            Get started
          </a>
          <a
            href="#features"
            onClick={scrollToFeatures}
            className="text-[14px] font-medium px-5 py-3 rounded-lg transition-colors"
            style={{
              color: '#f4f1ea',
              border: '0.5px solid rgba(255,255,255,0.15)',
              backgroundColor: 'transparent',
            }}
          >
            See how it works
          </a>
        </div>
      </div>
    </section>
  );
}
